/**
 * @generated SignedSource<<1efc66edd2c5ade34d8480a4c428c576>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreambleRecord_content$data = {
  readonly id: string;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "PreambleRecord_content";
};
export type PreambleRecord_content$key = {
  readonly " $data"?: PreambleRecord_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreambleRecord_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreambleRecord_content",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "PreambleRecord",
  "abstractKey": null
};

(node as any).hash = "1fcee6733f99e65f5b085475fdd80fe0";

export default node;
